import { render, staticRenderFns } from "./ListaDepartamento.vue?vue&type=template&id=f7f85196"
import script from "./ListaDepartamento.vue?vue&type=script&lang=js"
export * from "./ListaDepartamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports